// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36Bi1","largestCol":"styles_largestCol__wStzV","smallestCol":"styles_smallestCol__3BHOZ"};